import { http, HttpResponse } from 'msw'

import { VendorPaymentMethodApiModelStub } from '../api-models/stubs/VendorPaymentMethodApiModel.stub'
import { type VendorPaymentMethodApiModel } from '../api-models/VendorPaymentMethodApiModel'

export const mockGetVendorPaymentMethodsSuccess = (
  paymentMethods: VendorPaymentMethodApiModel[] = [
    VendorPaymentMethodApiModelStub.build({
      id: 33,
      name: 'ACH',
      currency: { id: 1 },
    }),
    VendorPaymentMethodApiModelStub.build({
      id: 34,
      name: 'Cheque',
      currency: { id: 1 },
    }),
  ]
) => {
  return http.get(`/api/v3/vendors/:vendorId/`, () => {
    return HttpResponse.json(
      { data: { payment_methods: paymentMethods } },
      { status: 200 }
    )
  })
}
